import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { CompanyState } from "./types";
import CompanyService from "@/services/company.service";
import { AxiosError, AxiosResponse } from "axios";
import toast from "@/functions/toast.function";

const service: CompanyService = new CompanyService();

export const actions: ActionTree<CompanyState, RootState> = {
  login(_, callback: ActionCallback) {
    service
      .login(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  request(_, callback: ActionCallback) {
    service
      .request(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          toast.success("Success.");
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
  reset(_, callback: ActionCallback) {
    service
      .reset(callback?.params)
      .then((response: AxiosResponse) => {
        if (response?.data) {
          toast.success("Success.");
          if (callback && callback.success) callback.success(response);
        }
      })
      .catch((error: AxiosError) => {
        if (callback && callback.fail) callback.fail(error);
      })
      .finally(() => {
        if (callback && callback.finally) callback.finally();
      });
  },
};
